import * as React from "react";
import {Dialog, Theme, Typography, WithStyles, withStyles} from "@material-ui/core";
//@ts-ignore
import CircularIndeterminate from 'hcla-web-frontend-primitives/app/components/primitives/Progress/CircularIndeterminate';

import {injectIntl, WrappedComponentProps} from "react-intl";
import createStyles from "@material-ui/core/styles/createStyles";
// @ts-ignore
import ReactTable, {Column} from "react-table";
import 'react-table/react-table.css';
//@ts-ignore
import CopyToClipboardChip from "hcla-web-frontend-primitives/app/components/primitives/Chips/CopyToClipboardChip";
import {QRCutsetListJSON, QRResultDataJSON,} from "../Quantification/QuantificationResultJSON";
import CutsetItemChip, { CutsetItemChipProps } from "./Chips/CutsetItemChip";
import {QCTypeParams} from "../Quantification/QuantificationConfigurationJSON";
import {PointEstimateQRCutsetListJSON} from "../Quantification/Types/PointEstimateQRJSON";
import {UncertainQRCutsetListJSON} from "../Quantification/Types/UncertainQRJSON";
import UncertainProbabilityChip from "./Chips/UncertainProbabilityChip";
import PointEstimateTTFChip from "./Chips/PointEstimateTTFChip";
import UncertainTTFChip from "./Chips/UncertainTTFChip";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import RiskCurvesContent from "../../Generic/RiskCurvesContent";
import { CalculatePointEstimate } from "../../Primitives/ProbabilityHelper";
import { mean } from 'mathjs';
const jsonexport = require('jsonexport');
const fileDownload = require('js-file-download');


const styles = (theme: Theme) => createStyles({
  root: {
    height: '100%',
    width: '100%',
    margin: '0',
    overflow: 'auto',
    padding: '0',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
  },
  subcomponent: {
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
    background: 'rgba(0, 0, 0, 0.03)',
  },
  tabContainer: {
    width: '100%',
    height: '100%',
  },
  tabsRoot: {
    height: 'calc(100% - 48px)',
    '& .react-swipeable-view-container': {
      height: '100%',
    },
  },
  cutsetChip: {
    margin: `0px ${theme.spacing(0.5)}px`,
    flexDirection: 'row',
  },
  cutsetRowItem: {
    flexDirection: 'row',
  },
  cutsetRow: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  rowItem: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  plotContainer: {
    width: "max-content",
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

export interface CutsetViewProps extends WithStyles<typeof styles>, WrappedComponentProps {
  resultData: QRResultDataJSON;
  type: QCTypeParams;
  noDataText?: JSX.Element;
  loadingText?: JSX.Element;
  loading?: boolean;
  cutsetItemChip?: any;
  riskCurves?: {[key: string]: any};
  treeTitle?: string;
  basicEvents?: any;
}

interface State {
  dialog: any;
  cutsetJSON: any;
  basicEventJSON: any;
}

const isCutsetEmpty = (data: QRResultDataJSON): boolean => {
  try {
    const { sequences, label_map } = data;
    return Object.keys(sequences).length <= 0 ||  Object.keys(label_map).length <= 0;
  } catch (e) {
    return true;
  }
};

const wrapHOCItemChip = (WrappedCutsetItemChip: any, props: CutsetItemChipProps) => <WrappedCutsetItemChip {...props} />

class CutsetView extends React.Component<CutsetViewProps, State> {
  public static defaultProps = {
    noDataText: <Typography variant="h5" align="center">Quantification Results Unavailable</Typography>,
    loadingText: <CircularIndeterminate size={80} color="secondary" />,
    cutsetItemChip: (props: CutsetItemChipProps) => <CutsetItemChip {...props} />,
    loading: false,
  };

  constructor(props: CutsetViewProps) {
    super(props);
    this.state = {
      dialog: null,
      cutsetJSON: {},
      basicEventJSON: {}
    }
  }

  componentDidMount() {
    this.getCutSetJSON();
    this.getBasicEventJSON();
  }

  getEndStateProbability = (data) => {
    const {type}  = this.props;
    let value;
    switch (type) {
      case QCTypeParams.POINT_ESTIMATE:
      case QCTypeParams.POINT_ESTIMATE_AT_FIXED_TIME:
        value = Number(data).toExponential(3);
        break;

      case QCTypeParams.UNCERTAINTY:
      case QCTypeParams.UNCERTAINTY_AT_FIXED_TIME:
        value = mean(data);
        break;

      case QCTypeParams.TIME_TO_FAILURE_CDF:
        value = CalculatePointEstimate(data);
        break;

      case QCTypeParams.TIME_TO_FAILURE_CDF_WITH_UNCERTAINTY:
        value = data
        break;

      default:
        value = Number(data).toExponential(3);
        break;
    }
    return value;
  }

  getCutSetJSON = () => {
    const { resultData } = this.props;
    const cutsetJSON: any = {};
    Object.keys(resultData.sequences).map(key => {
      const _probability = this.getEndStateProbability(resultData.sequences[key].result);
      const _cutsets = {};
      resultData.sequences[key].cutsets.map(item => {
        item.cutset.map(key => _cutsets[`_${resultData.label_map[key].label.name}_probability`] = item.probability)
      })

      cutsetJSON[key === 'SQ_F.0' ? 'Failure' : 'Success'] = {
        _probability,
        _cutsets
      }

    });

    this.setState({ cutsetJSON });
  }

  getBasicEventJSON = () => {
    const { basicEvents } = this.props;
    const basicEventJSON: any = {};
    if (basicEvents) {
      Object.keys(basicEvents).map(key => {
        basicEventJSON[basicEvents[key].label.name] = {
          _probability: basicEvents[key].expression.value,
        }
      })
    }

    this.setState({ basicEventJSON });
  }

  private handleExportCutsetClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    const { treeTitle } = this.props;
    const { cutsetJSON, basicEventJSON } = this.state;
    jsonexport({...cutsetJSON, ...basicEventJSON}, {fillTopRow: true}, function(err, csv){
      if (err) return console.error(err);
      fileDownload(csv, `${treeTitle}.csv`);
    });
  };


  public getCutsetColumns = (): Column<[string, QRCutsetListJSON]>[] => {
    const { resultData, intl, cutsetItemChip, classes: { cutsetRow, rowItem, cutsetRowItem, cutsetChip } } = this.props;
    return ([
      {
        id: 'ranking',
        maxWidth: 40,
        accessor: (d: any) => <div className={rowItem}><Typography align="center" variant="subtitle1">{d.ranking}</Typography></div>,
        Header: <Typography variant="h6" align="center">{intl.formatMessage({ id: 'FaultTreeResultView.Columns.Header.ranking' })}</Typography>,
      },
      {
        id: 'minimalCut',
        Header: <Typography variant="h6" align="center">{intl.formatMessage({ id: 'FaultTreeResultView.Columns.Header.minimalCut' })}</Typography>,
        accessor: (d: any) => (
          <div className={cutsetRow}>
            <div className={cutsetRowItem}>
              {
                d.cutset.map((x: string) => wrapHOCItemChip(cutsetItemChip, { name: x, map: resultData.label_map }))
              }
            </div>
          </div>
        ),
      },
      {
        id: 'probability',
        maxWidth: 120,
        Header: <Typography variant="h6" align="center">{intl.formatMessage({ id: 'FaultTreeResultView.Columns.Header.probability' })}</Typography>,
        accessor: (d: any) => <div className={rowItem}><CopyToClipboardChip color="secondary" variant="outlined" label={(d.probability).toExponential(3)} /></div>,
      },
    ]);
  };

  public getEndStateColumns = (): Column<[string, QRCutsetListJSON]>[] => {
    const { intl, resultData, type, classes: { rowItem }, riskCurves } = this.props;
    const nameColumn = {
      id: 'name',
      Header: <Typography variant="h6" align="center">{intl.formatMessage({ id: 'EventTreeResultView.Columns.endStates' })}</Typography>,
      accessor: (d: [string, QRCutsetListJSON]) => <CutsetItemChip variant="default" map={resultData.label_map} name={d[0]} />,
    };

    let acc;

    switch (type) {
      case QCTypeParams.POINT_ESTIMATE:
      case QCTypeParams.POINT_ESTIMATE_AT_FIXED_TIME:
        acc = (d: [string, PointEstimateQRCutsetListJSON]): JSX.Element => <div className={rowItem}><CopyToClipboardChip color="secondary" label={(d[1].result).toExponential(3)} /></div>;
        break;

      case QCTypeParams.UNCERTAINTY:
      case QCTypeParams.UNCERTAINTY_AT_FIXED_TIME:
        acc = (d: [string, UncertainQRCutsetListJSON]): JSX.Element => <UncertainProbabilityChip data={d[1].result} map={resultData.label_map} name={d[0]} />;
        break;

      case QCTypeParams.TIME_TO_FAILURE_CDF:
        acc = (d: [string, any]): JSX.Element => <PointEstimateTTFChip data={d[1].result} map={resultData.label_map} name={d[0]} />;
        break;

      case QCTypeParams.TIME_TO_FAILURE_CDF_WITH_UNCERTAINTY:
        acc = (d: [string, any]): JSX.Element => <UncertainTTFChip data={d[1].result} map={resultData.label_map} name={d[0]} />;
        break;

      default:
        acc = (d: [string, QRCutsetListJSON]): JSX.Element => <CopyToClipboardChip color="secondary" label={d[1].result} />;
        break;
    }

    const probColumn = {
      id: 'prob',
      maxWidth: 120,
      Header: <Typography variant="h6" align="center">{intl.formatMessage({ id: 'FaultTreeResultView.Columns.Header.probability' })}</Typography>,
      accessor: acc,
    };

    const showRiskCurvesColumn = riskCurves ? true : false;
    const riskCurvesColumn = {
      id: "risk curves",
      maxWidth: 120,
      Header: <Typography variant="h6" align="center">Risk Curves</Typography>,
      accessor: "",
      Cell: ( rowInfo: any ) => {
        const title = resultData.label_map[rowInfo.original[0]].label.name;
        const probability = rowInfo.original[1].result;
        return (
          <Button
            variant={"outlined"}
            color={"primary"}
            fullWidth
            onClick={() => this.openRiskCurveDialog(title, probability, rowInfo.original)}
          >
            View
          </Button>
        );
      },
      show: showRiskCurvesColumn
    }
    return [nameColumn, probColumn, riskCurvesColumn];
  };

  private openRiskCurveDialog = (title: string, probability: number, endState: any) => {
    const { classes, riskCurves } = this.props;
    if (!riskCurves) return;
    let noRiskCurveEndStates = ["SQ_CtOjx7KCn.3554", "SQ_hPdsHmVU_E.3554", "SQ_m0TfKyW5Y.3554", "SQ_bN3bPNV0qt.3554", "SQ_BU4E1hvvlA.3554", "SQ_OibYL5Vv4e.3554"];
    const hasNoCurve = noRiskCurveEndStates.includes(endState[0]);
    const acresXY = [
      Object.keys(riskCurves.acres).map((key) => riskCurves.acres[key][0]),
      Object.keys(riskCurves.acres).map((key) => hasNoCurve ? 0 : riskCurves.acres[key][1] * probability)
    ];
    const buildingImpactedXY = [
      Object.keys(riskCurves.building_impact).map((key) => riskCurves.building_impact[key][0]),
      Object.keys(riskCurves.building_impact).map((key) => hasNoCurve ? 0 : riskCurves.building_impact[key][1] * probability)
    ];
    const populationImpactedXY = [
      Object.keys(riskCurves.population_impact).map((key) => riskCurves.population_impact[key][0]),
      Object.keys(riskCurves.population_impact).map((key) => hasNoCurve ? 0 : riskCurves.population_impact[key][1] * probability)
    ];
    const dialog = (
      <Dialog
        fullWidth
        maxWidth={false}
        open={true}
        onClose={() => this.setState({ dialog: null })}
        classes={{ paper: classes.root }}
      >
        <DialogTitle>
          {`Risk Curves - ${title}`}
          <IconButton aria-label="close" className={classes.closeButton} onClick={() => this.setState({ dialog: null })}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <RiskCurvesContent
            type={"assets"}
            acresXY={acresXY}
            buildingImpactedXY={buildingImpactedXY}
            populationImpactedXY={populationImpactedXY}
          />
        </DialogContent>
      </Dialog>
    )
    this.setState({ dialog });
  }

  public render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

    const { loading, classes, loadingText, noDataText, resultData, intl } = this.props;
    const { dialog } = this.state;

    let content;
    if (loading) {
      content = loadingText;
    }

    else if (isCutsetEmpty(resultData)) {
      content = noDataText;
    }

    else {
      content = (
        <ReactTable
          data={Object.entries(resultData.sequences)}
          noDataText={intl.formatMessage({ id: 'FaultTreeResultView.table.no_result' })}
          columns={this.getEndStateColumns()}
          defaultPageSize={10}
          style={{ height: '100%' }}
          className="-striped -highlight"
          SubComponent={(row: any) => {
            return (
              <div className={classes.subcomponent}>
                <ReactTable
                  data={row.original[1].cutsets}
                  noDataText={intl.formatMessage({ id: 'FaultTreeResultView.table.no_result' })}
                  columns={this.getCutsetColumns()}
                  defaultPageSize={5}
                  className="-striped -highlight"
                />
              </div>
            );
          }}
        />
      );
    }
    return (
      <div className={classes.root}>
        {content}
        {dialog}
        <Button onClick={this.handleExportCutsetClick} fullWidth><Typography variant={"subtitle1"}>Export Results</Typography></Button>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(injectIntl(CutsetView));
